import {
SAVE_I130_BIOGRAPHICS_STARTED,SAVE_I130_BIOGRAPHICS_SUCCESS,SAVE_I130_BIOGRAPHICS_FAILED,
UPDATE_I130_BIOGRAPHICS_STARTED,UPDATE_I130_BIOGRAPHICS_SUCCESS,UPDATE_I130_BIOGRAPHICS_FAILED,
GET_I130_BIOGRAPHICS_STARTED,GET_I130_BIOGRAPHICS_SUCCESS,GET_I130_BIOGRAPHICS_FAILED,

SAVE_I130FORMS_STARTED,SAVE_I130FORMS_SUCCESS,SAVE_I130FORMS_FAILED,
UPDATE_I130FORMS_STARTED,UPDATE_I130FORMS_SUCCESS,UPDATE_I130FORMS_FAILED,
GET_I130FORMS_STARTED,GET_I130FORMS_SUCCESS,GET_I130FORMS_FAILED,
SAVEPDF_I130FORMS_SUCCESS,SAVEPDF_I130FORMS_FAILED,SAVEPDF_I130FORMS_STARTED,

SAVE_I130AFORMS_STARTED,SAVE_I130AFORMS_SUCCESS,SAVE_I130AFORMS_FAILED,
UPDATE_I130AFORMS_STARTED,UPDATE_I130AFORMS_SUCCESS,UPDATE_I130AFORMS_FAILED,
GET_I130AFORMS_STARTED,GET_I130AFORMS_SUCCESS,GET_I130AFORMS_FAILED,
SAVEPDF_I130AFORMS_SUCCESS,SAVEPDF_I130AFORMS_FAILED,SAVEPDF_I130AFORMS_STARTED,

SAVE_I131FORMS_STARTED,SAVE_I131FORMS_SUCCESS,SAVE_I131FORMS_FAILED,
UPDATE_I131FORMS_STARTED,UPDATE_I131FORMS_SUCCESS,UPDATE_I131FORMS_FAILED,
GET_I131FORMS_STARTED,GET_I131FORMS_SUCCESS,GET_I131FORMS_FAILED,
SAVEPDF_I131FORMS_SUCCESS,SAVEPDF_I131FORMS_FAILED,SAVEPDF_I131FORMS_STARTED,


SAVE_I864FORMS_STARTED,SAVE_I864FORMS_SUCCESS,SAVE_I864FORMS_FAILED,
UPDATE_I864FORMS_STARTED,UPDATE_I864FORMS_SUCCESS,UPDATE_I864FORMS_FAILED,
GET_I864FORMS_STARTED,GET_I864FORMS_SUCCESS,GET_I864FORMS_FAILED,
SAVEPDF_I864FORMS_SUCCESS,SAVEPDF_I864FORMS_FAILED,SAVEPDF_I864FORMS_STARTED,

SAVE_I485FORMS_STARTED,SAVE_I485FORMS_SUCCESS,SAVE_I485FORMS_FAILED,
UPDATE_I485FORMS_STARTED,UPDATE_I485FORMS_SUCCESS,UPDATE_I485FORMS_FAILED,
GET_I485FORMS_STARTED,GET_I485FORMS_SUCCESS,GET_I485FORMS_FAILED,
SAVEPDF_I485FORMS_SUCCESS,SAVEPDF_I485FORMS_FAILED,SAVEPDF_I485FORMS_STARTED

      } from '../actions/I130Case';
      const intialData= {
    status: {
        statusCode: 300,
        statusDisplay: "",
        statusValue: true
    },
    items: [],
    userInput: {       
        insert_datetime:"",
        inserted_by:"",
        update_datetime:"",
        updated_by:""
    
    },
    isLoading: true,
    isFormSubmit: false,
    isLoggedIn: false,
    error: ''
};

export const i130BioGraphicsData = (state = intialData, action: any) => {
 
  switch (action.type) {
      case SAVE_I130_BIOGRAPHICS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case SAVE_I130_BIOGRAPHICS_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case SAVE_I130_BIOGRAPHICS_FAILED:
    return {
      ...state,
      isLoading: true,
    }; 
    case UPDATE_I130_BIOGRAPHICS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case UPDATE_I130_BIOGRAPHICS_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case UPDATE_I130_BIOGRAPHICS_FAILED:
    return {
      ...state,
      isLoading: true,
    };  

     case GET_I130_BIOGRAPHICS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case GET_I130_BIOGRAPHICS_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case GET_I130_BIOGRAPHICS_FAILED:
    return {
      ...state,
      isLoading: true,
    }; 
  default:
        return state;
    }
    
}  

export const i130FormData = (state = intialData, action: any) => {

  switch (action.type) {
      case SAVE_I130FORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case SAVE_I130FORMS_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case SAVE_I130FORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    }; 
    case UPDATE_I130FORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case UPDATE_I130FORMS_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case UPDATE_I130FORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    };  

     case GET_I130FORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case GET_I130FORMS_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case GET_I130FORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    }; 
  default:
        return state;
    }
    
}  

export const i130FormPdfData = (state = intialData, action: any) => {

  switch (action.type) {
    case SAVEPDF_I130FORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case SAVEPDF_I130FORMS_SUCCESS:
      return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case SAVEPDF_I130FORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    
    default:
        return state;
    }
    
}

export const i130AFormData = (state = intialData, action: any) => {

  switch (action.type) {
      case SAVE_I130AFORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case SAVE_I130AFORMS_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case SAVE_I130AFORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    }; 
    case UPDATE_I130AFORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case UPDATE_I130AFORMS_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case UPDATE_I130AFORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    };  

     case GET_I130AFORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case GET_I130AFORMS_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case GET_I130AFORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    }; 
  default:
        return state;
    }
    
}  

export const i130AFormPdfData = (state = intialData, action: any) => {

  switch (action.type) {
    case SAVEPDF_I130AFORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case SAVEPDF_I130AFORMS_SUCCESS:
      return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case SAVEPDF_I130AFORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    
    default:
        return state;
    }
    
}

export const i131FormData = (state = intialData, action: any) => {

  switch (action.type) {
      case SAVE_I131FORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case SAVE_I131FORMS_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case SAVE_I131FORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    }; 
    case UPDATE_I131FORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case UPDATE_I131FORMS_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case UPDATE_I131FORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    };  

     case GET_I131FORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case GET_I131FORMS_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case GET_I131FORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    }; 
  default:
        return state;
    }
    
}  

export const i131FormPdfData = (state = intialData, action: any) => {

  switch (action.type) {
    case SAVEPDF_I131FORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case SAVEPDF_I131FORMS_SUCCESS:
      return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case SAVEPDF_I131FORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    
    default:
        return state;
    }
    
}

export const i864FormData = (state = intialData, action: any) => {

  switch (action.type) {
      case SAVE_I864FORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case SAVE_I864FORMS_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case SAVE_I864FORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    }; 
    case UPDATE_I864FORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case UPDATE_I864FORMS_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case UPDATE_I864FORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    };  

     case GET_I864FORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case GET_I864FORMS_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case GET_I864FORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    }; 
  default:
        return state;
    }
    
}  

export const i864FormPdfData = (state = intialData, action: any) => {

  switch (action.type) {
    case SAVEPDF_I864FORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case SAVEPDF_I864FORMS_SUCCESS:
      return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case SAVEPDF_I864FORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    
    default:
        return state;
    }
    
}

export const i485FormData = (state = intialData, action: any) => {

  switch (action.type) {
      case SAVE_I485FORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case SAVE_I485FORMS_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case SAVE_I485FORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    }; 
    case UPDATE_I485FORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case UPDATE_I485FORMS_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case UPDATE_I485FORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    };  

     case GET_I485FORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case GET_I485FORMS_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case GET_I485FORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    }; 
  default:
        return state;
    }
    
}  

export const i485FormPdfData = (state = intialData, action: any) => {

  switch (action.type) {
    case SAVEPDF_I485FORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case SAVEPDF_I485FORMS_SUCCESS:
      return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case SAVEPDF_I485FORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    
    default:
        return state;
    }
    
}